import React from 'react';
import UserTabPurchase from './UserTabPurchase';
import UserTabMemo from './UserTabMemo';
import UserTabAttendance from './UserTabAttendance';

const UserTab = ({idx}) => {

  console.log("userTabIdx: ", idx);
  return(

      <div className="card">
        <div className="card-body">

          <h5 className="card-title">Member related contents</h5>

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className="nav-link active" id="purchase-tab" data-bs-toggle="tab" data-bs-target="#userPurchase" type="button" role="tab" aria-controls="profile" aria-selected="false">구매이력</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="memo-tab" data-bs-toggle="tab" data-bs-target="#userMemo" type="button" role="tab" aria-controls="contact" aria-selected="false">메모/변경이력</button>
            </li>
            <li className="nav-item" role="presentation">
              <button className="nav-link" id="attendance-tab" data-bs-toggle="tab" data-bs-target="#userAttendance" type="button" role="tab" aria-controls="home" aria-selected="true">출석정보</button>
            </li>
          </ul>

          <div className="tab-content pt-2" id="myTabContent">
            <div className="tab-pane fade show active" id="userPurchase" role="tabpanel" aria-labelledby="purchase-tab">
              <UserTabPurchase idx={idx} />
            </div>
            <div className="tab-pane fade" id="userMemo" role="tabpanel" aria-labelledby="memo-tab">
              <UserTabMemo idx={idx} />
            </div>
            <div className="tab-pane fade" id="userAttendance" role="tabpanel" aria-labelledby="attendance-tab">
              <UserTabAttendance idx={idx} />
            </div>
          </div>

        </div>
      </div>



  );
}

export default UserTab;




